// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spenden-statt-geschenke/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendenStattGeschenkeDE: PageEntry = {
  id: "post.spenden-statt-geschenke",
  locale: "de",
  slug: "spenden-statt-geschenke",
  seo: {
    title: "Spenden statt Geschenke | Dietz GmbH",
    description: "Spenden statt Geschenke",
  },
  type: "post",
  h1: "Spenden statt Geschenke",
  blocks: [
    { kind: "heading", level: 2, text: "Spenden statt Geschenke" },
    { kind: "paragraph", text: "Mit seinen 16 Jahren musste Felix leider in diesem Jahr einen Schicksalsschlag erleben und verlor beide Unterschenkel." },
    { kind: "paragraph", text: "Im Rahmen der 2. HSC-Weihnachtstombola hatten unsere Mitarbeiter die Möglichkeit am Dietz-Empfang Weihnachtlose zu kaufen. Ein Los kostete 5 Euro – für jedes gekaufte Los legten wir nochmal 2 Euro drauf, die dem Neustadter zugutekommen." },
    { kind: "paragraph", text: "Wir danken allen Spendern für ihre enorme Hilfsbereitschaft, durch die wir die Spendensumme von 5.100,00 Euro erzielen konnten (100,00 Euro Dietz-Zuschuss nach dem Losverkauf)." },
    { kind: "paragraph", text: "Wir hoffen, dass wir einen Beitrag für die notwendigen Umbaumaßnahmen für ihren Felix beisteuern können." },
    { kind: "paragraph", text: "Wir wünschen Felix und seine Familie alles Gute für die Zukunft und ein besinnliches Weihnachtsfest" },
    { kind: "paragraph", text: "Matthias und Andrea Dietz Dietz GmbH" }
  ],
};
